class TrackCursor extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.cursorSettings = {
      x: 0,
      y: 0,
    }

    this.initialise()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.control?.exists) return

    this.handleMouseMove = this.handleMouseMove.bind(this)

    this.listeners.add(this, 'mousemove', this.handleMouseMove)
  }

  initialise () {
    if (!this.els?.control?.exists) return

    this.control = this.els.control.element

    this.renderCursorPosition = this.renderCursorPosition.bind(this)

    requestAnimationFrame(this.renderCursorPosition)
  }

  handleMouseMove (event) {
    if (!window.matchMedia('(min-width: 768px)')) return

    const rect = this.getBoundingClientRect()

    const controlHeight = this.control.offsetHeight / 2
    const mouseY = event.clientY - rect.top - controlHeight
    this.cursorSettings.y = mouseY

    if (this.dataset.trackX === 'true') {
      const controlWidth = this.control.offsetWidth / 2
      const mouseX = event.clientX - controlWidth
      this.cursorSettings.x = mouseX
    }

    requestAnimationFrame(this.renderCursorPosition)
  }

  renderCursorPosition () {
    if (!window.matchMedia('(min-width: 768px)')) return

    if (this.dataset.offset === 'true') {
      this.control.style.transform = `translate3d(${this.cursorSettings.x}px, ${this.cursorSettings.y - 12}px, 0px)`
    } else {
      this.control.style.transform = `translate3d(${this.cursorSettings.x}px, ${this.cursorSettings.y}px, 0px)`
    }
  }
}

if (!customElements.get('track-cursor')) {
  customElements.define('track-cursor', TrackCursor)
}
